import React from 'react'
import { useSelector } from 'react-redux'
import CreateVirtualCardForm, {
  CreateVirtualCardScreen,
} from 'src/app/CreateVirtualCardForm/CreateVirtualCardForm'
import RightFlyout, {
  RightFlyoutBodyWidths,
} from 'src/components/RightFlyout/RightFlyout'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

const CreateBillPay: React.FC = () => {
  const location = useSelector(selectLocationFromState)
  return (
    <RightFlyout width={RightFlyoutBodyWidths.Action}>
      <CreateVirtualCardForm
        screen={
          (location.state?.screen as CreateVirtualCardScreen) ??
          CreateVirtualCardScreen.BillPay
        }
      />
    </RightFlyout>
  )
}

export default CreateBillPay
